import script from "./OrientationSwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrientationSwitcher.vue?vue&type=script&setup=true&lang=ts"

import "./OrientationSwitcher.vue?vue&type=style&index=0&id=7fcfe4e2&lang=scss"

const __exports__ = script;

export default __exports__